export default {
    _prefix: "qualityFormEditor.visibilityCondition",
    labels: {
        title: "Show this when {{condition}} of the following responses are selected.",
        includeTitle:
            "Include this when {{condition}} of the following responses are selected.",
        all: "all",
        any: "any",
        addVisibilityCondition: "Add Condition",
        selectQuestion: "Select Question",
        selectAnswer: "Select Answer",
        dropDownOptions: "Drop down options",
        noText: "No Text",
    },
    errors: {
        noConditionLeft: "There are no more responses left to be added.",
    },
    npsAnswerOptions: {
        DETRACTOR: "Detractor",
        PASSIVE: "Passive",
        PROMOTER: "Promoter",
    },
};
